export const ar = {
  nav: {
    home: 'الرئيسية',
    services: 'الخدمات',
    about: 'من نحن',
    portfolio: 'الأعمال',
    contact: 'اتصل بنا',
    getStarted: 'ابدأ الآن',
  },

  hero: {
    tagline: 'وكالة إبداعية',
    title: 'الابتكار يلتقي',
    titleHighlight: 'الإلهام',
    subtitle: 'نصنع تجارب تسويقية جريئة لا تُنسى ترفع من مستوى علامتك التجارية.',
    cta: 'ابدأ مشروعك',
    watchVideo: 'شاهد الفيديو',
    servicesButton: 'استكشاف الخدمات',
    scrollText: 'مرر الشاشة للاستكشاف',
  },

  services: {
    tag: 'ماذا نفعل',
    title: 'خدماتنا',
    titleHighlight: 'المميزة',
    subtitle: 'حلول إبداعية شاملة لرفع مستوى علامتك التجارية.',
    
    items: [
      {
       icon: '🎨',
        title: 'العلامة التجارية',
        description: 'إنشاء هوية تجارية لا تُنسى تتفاعل مع جمهورك المستهدف.',
      },
      {
        icon: '📢',
        title: 'الإعلان',
        description: 'حملات استراتيجية تجذب الانتباه وتحقق نتائج قابلة للقياس.',
      },
      {
        icon: '✏️',
        title: 'التصميم',
        description: 'تصاميم بصرية مذهلة تنقل قصة علامتك التجارية بفعالية.',
      },
      {
        icon: '🌐',
        title: 'التسويق الرقمي',
        description: 'استراتيجيات قائمة على البيانات لتعظيم تواجدك على الإنترنت.',
      },
      {
        icon: '🎬',
        title: 'الإنتاج المرئي',
        description: 'إنتاج فيديو احترافي يُحيي قصة علامتك التجارية.',
      },
      {
        icon: '💻',
        title: 'تطوير المواقع',
        description: 'مواقع ويب مخصصة ومتجاوبة توفر تجارب مستخدم استثنائية.',
      },
      {
        icon: '📱',
        title: 'تطبيقات الجوال',
        description: 'تطبيقات جوال سهلة الاستخدام لمنصتي iOS و Android.',
      },
    ],
  },

  about: {
    tag: 'من نحن',
    title: 'لماذا تختار',
    titleHighlight: 'أورفين',
    subtitle: 'نحن فريق من المبدعين المتحمسين المخصصين لتحويل العلامات التجارية.',
    
    stats: [
      { number: 78, label: 'مشروع مكتمل', suffix: '+' },
      { number: 98, label: 'رضا العملاء', suffix: '%' },
      { number: 4, label: 'عضو فريق', suffix: '+' },
      { number: 5, label: 'سنة خبرة', suffix: '' },
    ],

    features: [
      {
        title: 'التميز الإبداعي',
        description: 'فريق إبداعي حائز على جوائز مع سجل حافل.',
      },
      {
        title: 'نهج استراتيجي',
        description: 'استراتيجيات قائمة على البيانات تحقق نتائج قابلة للقياس.',
      },
      {
        title: 'التركيز على العميل',
        description: 'نجاحك هو أولويتنا. نستمع ونتكيف ونقدم.',
      },
    ],
  },

  portfolio: {
    tag: 'أعمالنا',
    title: 'مشاريع',
    titleHighlight: 'مميزة',
    subtitle: 'استكشف محفظة أعمالنا من المشاريع الناجحة.',
    close:'أغلق',
    categories: {
      all: 'كل المشاريع',
      branding: 'العلامة التجارية',
      webDesign: 'تصميم الويب',
      marketing: 'التسويق',
      appDesign: 'تصميم التطبيقات',
      video: 'الفيديو',
      design: 'التصميم',
    },

    viewProject: 'عرض المشروع',
    featured: 'مميز',
    client: 'العميل',
    year: 'السنة',
    viewLive: 'عرض المشروع المباشر',
  },

  contact: {
    tag: 'تواصل معنا',
    title: 'لنصنع شيئاً',
    titleHighlight: 'مذهلاً',
    subtitle: 'هل أنت مستعد لنقل علامتك التجارية إلى المستوى التالي؟',
    
    form: {
      namePlaceholder: 'اسمك *',
      emailPlaceholder: 'بريدك الإلكتروني *',
      subjectPlaceholder: 'الموضوع (اختياري)',
      messagePlaceholder: 'أخبرنا عن مشروعك... *',
      sendButton: 'إرسال الرسالة 🚀',
      sending: 'جاري الإرسال...',
      requiredNote: '* الحقول المطلوبة | سنرد خلال 24 ساعة',
    },

    info: {
      email: 'البريد الإلكتروني',
      phone: 'الهاتف',
      location: 'الموقع',
    },

    success: {
      title: 'تم إرسال الرسالة بنجاح! 🎉',
      message: 'لقد استلمنا رسالتك. سيتواصل معك فريقنا خلال 24 ساعة!',
    },

    errors: {
      nameRequired: 'يجب أن يحتوي الاسم على حرفين على الأقل',
      emailInvalid: 'يرجى إدخال عنوان بريد إلكتروني صالح',
      messageRequired: 'يجب أن تحتوي الرسالة على 10 أحرف على الأقل',
      subjectTooLong: 'يجب أن يكون الموضوع أقل من 100 حرف',
      fixErrors: 'يرجى إصلاح الأخطاء في النموذج',
      sendFailed: 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
    },
  },

  footer: {
    tagline: 'الابتكار يلتقي الإلهام',
    about: 'نحن وكالة إبداعية مخصصة لصنع تجارب تسويقية لا تُنسى.',
    quickLinks: 'روابط سريعة',
    services: 'الخدمات',
    followUs: 'تابعنا',
    copyright: '© 2026 وكالة أورفين الإبداعية. جميع الحقوق محفوظة.',
    privacyPolicy: 'سياسة الخصوصية',
    termsOfService: 'شروط الخدمة',
    craftedWith: 'صُنعت بشغف',
  },
};

